export default __webpack_public_path__ + "scripts/resources/assignments/en/chemvlab/thermodynamics/Solar1/reactions.json";